import { useEffect, useState } from "react";
import axios from "axios";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

const RendomTokenData = () => {
  const [rendomToken, setrendomToken] = useState(null);
  useEffect(() => {
    const FetchRendomToken = async () => {
      let fdata = new FormData();
      fdata.append("Status", "1");
      try {
        await axios
          .post(`${WebsiteAPIurl}rendomTokenfetch`, fdata)
          .then((response) => {
            // console.log(response.data);
            setrendomToken(response.data.token);
          });
      } catch (err) {
        alert(err.message);
      }
    };
    FetchRendomToken();
  }, []);

  return rendomToken;
};

export default RendomTokenData;
